export default __webpack_public_path__ + "static/media/edit.cf4faa4e.svg";